module.exports = __webpack_public_path__ + "img/yclients.0316b9b2.png";